import { Badge } from '@components'
import styled from 'styled-components'

/** Slightly smaller-than-default success badges for yearly “Save” and plan discount %. White background, green outline (same as Badge). */
export const CompactPricingSuccessBadge = styled(Badge).attrs({ type: 'success' })`
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  font-weight: 600;

  &.success {
    background-color: ${({ theme }) => theme.colors.neutralWhite};
  }

  & > div {
    padding: ${({ theme }) => theme.spacing.xxs}rem ${({ theme }) => theme.spacing.sm}rem;
    min-height: 0;
  }
`
